/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoicesService {
    /**
     * List all invoices
     * Get a paginated list of invoices for the authenticated user
     * @param clientId Filter by client ID
     * @param invStatus Filter by invoice status
     * @returns any List of invoices
     * @throws ApiError
     */
    public static f86601Dff5362250710476B314Be6(
        clientId?: number,
        invStatus?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices',
            query: {
                'client_id': clientId,
                'inv_status': invStatus,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new invoice
     * Create a new invoice for a client
     * @param requestBody
     * @returns any Invoice created successfully
     * @throws ApiError
     */
    public static ac969F519682D839297C530D5C(
        requestBody: {
            client_id: number;
            invoice_no: string;
            sub_total_amount: number;
            tax_amount?: number | null;
            total_amount: number;
            inv_status: string;
            due_date: string;
            inv_date: string;
            remarks?: string | null;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific invoice
     * Retrieve details of a specific invoice
     * @param id Invoice ID
     * @returns any Invoice details
     * @throws ApiError
     */
    public static d266Eac4A087Db1Ce1B1A88A27C5864(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Invoice not found`,
            },
        });
    }
    /**
     * Update an invoice
     * Update an existing invoice
     * @param id Invoice ID
     * @param requestBody
     * @returns any Invoice updated successfully
     * @throws ApiError
     */
    public static ec124E53679451F551E7D5F3Ed9Deea(
        id: number,
        requestBody: {
            inv_status?: string;
            total_amount?: number;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoices/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Invoice not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete an invoice
     * Delete an invoice
     * @param id Invoice ID
     * @returns any Invoice deleted successfully
     * @throws ApiError
     */
    public static bac32Ace10C9Dec32991Fad318(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoices/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Invoice not found`,
            },
        });
    }
}
